import React, { useEffect, useState ,useContext} from "react";
import { Col, Container, Row } from "react-bootstrap";
import { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import MediaBanner from "./MediaBanner/MediaBanner";
import PressRelease from "./PressRelease/PressRelease";
import '../MediaCenter/PressRelease/PressRelease.css'
import MediaContact from "./MediaContact/MediaContact";
import CompanyBoilerplate from "./CompanyBoilerplate/CompanyBoilerplate";
import InnerPressRelease from "./PressRelease/InnerPressRelease/InnerPressRelease";
import MeadiaVdieos from "./PressRelease/MeadiaVdieos/MeadiaVdieos";
import URLstateContext from "../../provider/CommonContext";
import { GetPostMethodData,DecryptAESdata } from "../../provider/ServiceProvider";

function MediaCenter() {
    const [data,setData] = useState('');
    
    const [value, setValue] = React.useState(1);
    const [pathname, setPathName] = useState('');
    const { fontSize, changeFontSize, resetFontSize, changeFontSizeMinus } = useContext(URLstateContext);
    useEffect(() => {
        const pathname = window.location.pathname;
        const lastSegment = pathname.slice(pathname.lastIndexOf('/') + 1);
        const CategoryIdUrlid = lastSegment;
        setPathName(CategoryIdUrlid);
    })

  
    const arrayOfTabsObj = [
        // { name: "Press Release", id: 1 },
        { name: "Press Release", id: 1 },
        { name: "Videos", id: 4 },
        // { name: "Podcast", id: 5 },
        // { name: "Social Media", id: 6 },
        // { name: "Company Boilerplate", id: 3 },

    ];
    const navigate = useNavigate();
    const handleChange = (event, newValue) => {
        setValue(newValue);
        const selectedTab = arrayOfTabsObj.find(tab => tab.id === newValue);
        navigate(`/Communication-Center/${selectedTab.name.replace(/\s+/g, '')}`);
    };
    useEffect(() => {
        var para = window.location.pathname.toLocaleLowerCase().split('/')[2];
        if (para === "pressrelease") setValue(1)
        if (para === "mediacontact") setValue(2)
        if (para === "companyboilerplate") setValue(3)
        if (para === "videos") setValue(4)
    }, []);
    return (
        <>
            <MediaBanner />
            <section className="Nav-detail about-detail reachout Media-center" style={{ fontSize: `${fontSize}px` }}>
                <Container>
                    <Row>
                        <Col>
                            <ul className="navigator-arrow">
                                <li><a href="/" aria-label="Home"><i class="fa fa-home" aria-hidden="true"></i></a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                                <li><a href="/Communication-Center"><i>Communication Center</i></a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                                {/* <li>Calculator</li><i class="fa fa-angle-right" aria-hidden="true"></i> */}
                                {window.location.pathname != "/Communication-Center" ? <li>{pathname.replace(/([a-z])([A-Z])/g, '$1 $2')}</li> : ''}
                            </ul>
                        </Col>
                    </Row>
                </Container>

                <Box>
                    <TabContext value={value}>
                        <Container className="tabs-nav">
                            <Row>
                                <Col sm={12}>
                                    <Box sx={{ width: "100%" }}

                                    >
                                        <TabList
                                            onChange={handleChange}
                                            variant="scrollable"
                                            sx={{
                                                [`& .${tabsClasses.scrollButtons}`]: {
                                                    "&.Mui-disabled": { opacity: 0.3 },
                                                },
                                            }}
                                            className="press-tabs"
                                            scrollButtons="auto"
                                        >
                                             {/* {(arrayOfTabsObj === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''} */}
                                            {arrayOfTabsObj.map((item) => (
                                                <Tab className={item.id == 3 ? "width185" : "width125"} label={item.name} value={item.id}></Tab>
                                            ))}
                                        </TabList>
                                    </Box>
                                </Col>
                            </Row>
                        </Container>



                        {/* <Container>
                            <Row>
                                <Col> */}
                        <TabPanel value={1}>
                            <InnerPressRelease></InnerPressRelease>
                        </TabPanel>
                        <TabPanel value={4}>
                            <MeadiaVdieos></MeadiaVdieos>
                                                    </TabPanel>
                        {/* <TabPanel value={3}>
                            <CompanyBoilerplate></CompanyBoilerplate>
                        </TabPanel> */}
                        {/* </Col>
                            </Row>
                        </Container> */}
                    </TabContext>
                </Box>
            </section>

        </>
    )
}

export default MediaCenter